// extracted by mini-css-extract-plugin
export default {"advertDetailParameterList":"c-n_he","advertDetailParameterList__header":"c-n_hf","advertDetailParameterList__list":"c-n_hg"};